import React from "react";
import "./Loader.css";

function Loader() {
  return <span className="loader">Loading</span>;
}

export default Loader;
